import { gql } from "@apollo/client";


export const GET_NOTIFICATIONS = gql`
  query getWebNotifications(
    $sinceDate: timestamptz!
    $untilDate: timestamptz!
    $recentCutoff: timestamptz!
    $pageSize: Int!
    $cursor: timestamptz!
    $userId: uuid!
  ) {
    all: feed(
      where: {
        user_feeds: {
          uf_deleted_at: { _is_null: true }
          uf_is_read: { _eq: false }
          u_id: { _eq: $userId }
          user: {
            u_deleted_at: { _is_null: true }
            u_is_active: { _eq: true }
            _or: [
              { u_role: { _in: ["admin", "logitix_user", "sub_admin", "marketing_user"] } }
              { u_allowed_roles: { _contains: "affiliater_admin" } }
              { u_allowed_roles: { _contains: "sub_admin" } }
              { u_allowed_roles: { _contains: "marketing_user" } }
            ]
          }
        }
        f_created_at: { _lt: $cursor, _gte: $sinceDate, _lte: $untilDate }
        f_deleted_at: { _is_null: true }
      }
      limit: $pageSize
      order_by: { f_created_at: desc }
    ) {
      f_id
      title: f_title
      type: f_type
      u_id
      tp_id_array
      notification: f_created_at
      user_feeds {
        user {
          userId: u_id
          userName: u_full_name
        }
      }
      ticket_placement {
        tp_id
      }
      ticket {
        t_id
        user {
          pricingMode: u_pricing_mode
        }
        ticket_placements {
          tp_internal_notes
          tp_external_notes
        }
        event {
          eventImage: e_image_url
          eventName: e_name
          eventDate: e_date
          eventAddress: e_address
          eventBrandName: e_brand_name
          eventStatus: e_status
          e_id
        }
      }
    }

    currentCount: feed_aggregate(
      where: {
        user_feeds: {
          uf_deleted_at: { _is_null: true }
          uf_is_read: { _eq: false }
          u_id: { _eq: $userId }
          user: {
            u_deleted_at: { _is_null: true }
            u_is_active: { _eq: true }
            _or: [
              { u_role: { _in: ["admin", "logitix_user", "sub_admin", "marketing_user"] } }
              { u_allowed_roles: { _contains: "affiliater_admin" } }
              { u_allowed_roles: { _contains: "sub_admin" } }
              { u_allowed_roles: { _contains: "marketing_user" } }
            ]
          }
        }
        f_created_at: { _gte: $recentCutoff, _lte: $untilDate }
        f_deleted_at: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }

    pastCount: feed_aggregate(
      where: {
        user_feeds: {
          uf_deleted_at: { _is_null: true }
          uf_is_read: { _eq: false }
          u_id: { _eq: $userId }
          user: {
            u_deleted_at: { _is_null: true }
            u_is_active: { _eq: true }
            _or: [
              { u_role: { _in: ["admin", "logitix_user", "sub_admin", "marketing_user"] } }
              { u_allowed_roles: { _contains: "affiliater_admin" } }
              { u_allowed_roles: { _contains: "sub_admin" } }
              { u_allowed_roles: { _contains: "marketing_user" } }
            ]
          }
        }
        f_created_at: { _gte: $sinceDate, _lt: $recentCutoff }
        f_deleted_at: { _is_null: true }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const CLEAR_ALL_NOTIFICATION = gql`
mutation ClearAllNotification {
  clearallnotification {
    uf_id
    uf_is_read
  }
}
`;

export const UPDATE_READ_STATUS = gql`
mutation UpdateUserFeed ($feedId: uuid!) {
  updateuserfeed(args: {feedid:$feedId}) {
    uf_id
    uf_is_read
  }
}
`;
export const UPDATE_READ_STATUS_BATCH = gql`
  mutation UpdateMultipleUserFeeds($feedIds: [uuid!]!) {
    update_user_feeds(
      where: { uf_id: { _in: $feedIds } }
      _set: { uf_is_read: true }
    ) {
      returning {
        uf_id
        uf_is_read
      }
    }
  }
`;